import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withIcon = false,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-4 text-lg font-semibold rounded-lg transition-all duration-200 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-teal-600 text-white hover:bg-teal-700 shadow-lg hover:shadow-xl focus:ring-teal-500 border border-transparent',
    secondary: 'bg-amber-500 text-white hover:bg-amber-600 shadow-md hover:shadow-lg focus:ring-amber-500 border border-transparent',
    outline: 'bg-white text-teal-700 border-2 border-teal-600 hover:bg-teal-50 focus:ring-teal-500'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  const content = <>
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-192" />}
    </>;
  if (href) {
    return <a href={href} className={combinedClassName} onClick={onClick as any} data-id="element-193">
        {content}
      </a>;
  }
  return <button className={combinedClassName} onClick={onClick} {...props} data-id="element-194">
      {content}
    </button>;
}